/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { Georegion } from './Georegion.js';
import { GeoZone } from './GeoZone.js';
import { ZoneLocality } from './ZoneLocality.js';
import { PropertyUsePropertyTypeGroup } from './PropertyUsePropertyTypeGroup.js';
import { PropertyTypeGroupPropertyType } from './PropertyTypeGroupPropertyType.js';
import { PropertyTypePropertySubType } from './PropertyTypePropertySubType';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import { useQuery } from 'react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { numberWithCommas } from '../Utils';


export const PropertySearch = () => {
  const location = useLocation();
  const [getBuyerData, setBuyerData] = useState(null);
  const [buyerSpecRef, setBuyerSpecRef] = useState(null);
  const [buyerSpecName, setBuyerSpecName] = useState(null);
  const [getgeoregion, setGetGeoregion] = useState(null);
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  const [bedroomsFrom, setBedroomsFrom] = useState(
    location?.state?.BedroomsFrom ?? '',
  );
  const [bedroomsTo, setBedroomsTo] = useState(
    location?.state?.BedroomsTo ?? '',
  );
  const [getPropertyUse, setGetPropertyUse] = useState(null);
  const [propertyTypeGroupId, setPropertyTypeGroupId] = useState(null);
  const [getzone, setGetZone] = useState(null);
  // Array of selected locality IDs
  const [getLocalityId, setGetLocalityId] = useState([]);
  const [propertyTypeId, setPropertyTypeId] = useState(null);
  const [getPropertySubTypeId, setGetPropertySubTypeId] =
    useState(null);
  const [rent, setRent] = useState(null);
  const [propertyRef, setPropertyRef] = useState(location?.state?.propertyRef);
  const [vendorName, setVendorName] = useState(location?.state?.vendorName);
  const [vendorSurname, setVendorSurname] = useState(location?.state?.vendorSurname);
  const [vendorPhone, setVendorPhone] = useState(location?.state?.vendorPhone);
  const [mandatoryErrorMessage, setMandatoryErrorMessage] =
    useState(null);
  const [minMaxError, setMinMaxError] = useState(null);
  const [minMaxBooleanValue, setMinMaxBooleanValue] = useState(null);
  const [forSale, setForSale] = useState(location?.state?.forSale);
  const [longlet, setLongLet] = useState(location?.state?.longlet);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Property Search';

    //Reset previous position of property search results
    localStorage.setItem('PropertySearchPosition', 0);
    localStorage.setItem('PropertySearchPageSize', 10); //Set 10 results
  }, []);

  useEffect(() => {
    console.log('state', location.state);
    if (location?.state?.forSale == 'true') {
      //Search is for sale
      setRent("false");
      //Set budget prev values
      if (location?.state?.salePriceFrom != null) {
        setMin(location?.state?.salePriceFrom);
      }
      if (location?.state?.salePriceTo != null) {
        setMax(location?.state?.salePriceTo);
      }
    }
    if (location?.state?.longlet == 'true') {
      //Search is to let
      setRent("true");
      //Set budget prev values
      if (location?.state?.longletPriceFrom != null) {
        setMin(location?.state?.longletPriceFrom);
      }
      if (location?.state?.longletPriceTo != null) {
        setMax(location?.state?.longletPriceTo);
      }
    }
    if (location?.state?.BedroomsFrom != null) {
      setBedroomsFrom(String(location?.state?.BedroomsFrom));
    }
    if (location?.state?.BedroomsTo != null) {
      setBedroomsTo(String(location?.state?.BedroomsTo));
    }

    if (location?.state?.commercial != null || location?.state?.propertyUse != null) {
      if (location?.state?.commercial == 'true') {
        //Search Commercial
        setGetPropertyUse('true');
      } else if (location?.state?.propertyUse == 'true') {
        //Search Residential
        setGetPropertyUse('false');
      }

      if (location?.state?.propertyTypeGroupId != null) {
        setPropertyTypeGroupId(location?.state?.propertyTypeGroupId);

        if (location?.state?.propertyTypeId != null) {
          setPropertyTypeId(location?.state?.propertyTypeId);

          if (location?.state?.propertySubtypeId != null) {
            setGetPropertySubTypeId(location?.state?.propertySubtypeId);
          }
        }
      }
    }
    

    if (location?.state?.regionId != null) {
      setGetGeoregion(location?.state?.regionId);
      if (location?.state?.zoneId != null) {
        setGetZone(location?.state?.zoneId);

        if (location?.state?.localityId != null) {
          const localityVal = location?.state?.localityId;
          setGetLocalityId(
            Array.isArray(localityVal) ? localityVal : [localityVal]
          );
        }
      }
    }

    if (location?.state?.clientSpec) {
      setGetPropertyUse(null);
      setPropertyTypeGroupId(null);
      setGetGeoregion(null);
      setGetZone(null);
      setGetLocalityId(null);
      setPropertyTypeId(null);
      setGetPropertySubTypeId(null);
      setRent(null);

      if (location?.state?.clientSpec?.Residential) {
        setGetPropertyUse(location?.state?.clientSpec?.Residential);
      }
      if (location?.state?.clientSpec?.Commercial) {
        setGetPropertyUse(location?.state?.clientSpec?.Commercial);
      }
      if (location?.state?.clientSpec?.ForSale) {
        setRent(location?.state?.clientSpec?.ForSale);
      }
      if (location?.state?.clientSpec?.ToLet) {
        setRent(location?.state?.clientSpec?.ToLet);
      }
      if (location?.state?.clientSpec?.budgetMin) {
        setMin(
          numberWithCommas(location?.state?.clientSpec?.budgetMin),
        );
      } else {
        setMin('');
      }
      if (location?.state?.clientSpec?.budgetMax) {
        setMax(
          numberWithCommas(location?.state?.clientSpec?.budgetMax),
        );
      } else {
        setMax('');
      }
      const clientBedroomsFrom =
        location?.state?.clientSpec?.BedroomsFrom ??
        location?.state?.clientSpec?.bedroomsFrom;
      const clientBedroomsTo =
        location?.state?.clientSpec?.BedroomsTo ??
        location?.state?.clientSpec?.bedroomsTo;
      setBedroomsFrom(
        clientBedroomsFrom != null ? String(clientBedroomsFrom) : '',
      );
      setBedroomsTo(
        clientBedroomsTo != null ? String(clientBedroomsTo) : '',
      );
      setBuyerSpecRef(location?.state?.clientSpec?.buyerSpecRef);
      setBuyerSpecName(location?.state?.clientSpec?.buyerSpecName);
      setBuyerData(location?.state?.clientSpec);
      setGetGeoregion(location?.state?.clientSpec?.geoRegionId);
      const clientLocality = location?.state?.clientSpec?.localityId;
      setGetLocalityId(
        Array.isArray(clientLocality)
          ? clientLocality
          : clientLocality
          ? [clientLocality]
          : []
      );
      setPropertyTypeId(location?.state?.clientSpec?.propertyTypeId);
      setGetPropertySubTypeId(
        location?.state?.clientSpec?.propertySubTypeId,
      );
      setPropertyTypeGroupId(
        location?.state?.clientSpec?.propertyTypeGroupId,
      );
      setGetZone(location?.state?.clientSpec?.zoneId);
      toast.success(
        `Welcome to ${location?.state?.clientSpec?.buyerSpecName}'s spec`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
    }

    return () => {
      delete location?.state?.clientSpec;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location?.state?.commercial,
    location?.state?.forsale,
    location?.state?.localityId,
    location?.state?.longlet,
    location?.state?.longletPriceFrom,
    location?.state?.longletPriceTo,
    location?.state?.propertySubtypeId,
    location?.state?.propertyTypeGroupId,
    location?.state?.propertyTypeId,
    location?.state?.propertyref,
    location?.state?.vendorName,
    location?.state?.vendorSurname,
    location?.state?.vendorPhone,
    location?.state?.regionId,
    location?.state?.residential,
    location?.state?.salePriceFrom,
    location?.state?.salePriceTo,
    location?.state?.BedroomsFrom,
    location?.state?.BedroomsTo,
    location?.state?.zoneId,
    location?.state?.clientSpec]);

  const handleRentChange = (event) => {
    setMandatoryErrorMessage(null);
    event.preventDefault();
    event.persist();
    if (rent == event.target.dataset.rent) {
      setRent(null);
      return;
    }
    setRent(event.target.dataset.rent);
    setForSale(null);
    setLongLet(null);
  };

  const handleGeoRegion = (event) => {
    setMandatoryErrorMessage(null);
    setGetZone(null);
    setGetLocalityId([]);
    event.preventDefault();
    event.persist();
    if (getgeoregion == event.target.dataset.georegion) {
      setGetGeoregion(null);
      return;
    }
    setGetGeoregion(event.target.dataset.georegion);
  };

  const handleZone = (event) => {
    setMandatoryErrorMessage(null);
    setGetLocalityId([]);
    event.preventDefault();
    event.persist();
    if (getzone == event.target.dataset.zone) {
      setGetZone(null);
      return;
    }
    setGetZone(event.target.dataset.zone);
  };

  const handleLocality = (event) => {
    setMandatoryErrorMessage(null);
    event.preventDefault();
    event.stopPropagation();

    const locality = event.currentTarget.dataset.locality;

    setGetLocalityId((prev) => {
      const list = Array.isArray(prev)
        ? [...prev]
        : prev != null
        ? [prev]
        : [];

      if (list.some((id) => id == locality)) {
        return list.filter((id) => id != locality);
      }
      return [...list, locality];
    });

  };

  const handlePropertyUse = (event) => {
    setMandatoryErrorMessage(null);
    setPropertyTypeGroupId(null);
    setPropertyTypeId(null);
    event.preventDefault();
    event.persist();
    if (getPropertyUse == event.target.dataset.user) {
      setGetPropertyUse(null);
      return;
    }
    setGetPropertyUse(event.target.dataset.user);
  };

  const handlePropertyTypeGroup = (event) => {
    setMandatoryErrorMessage(null);
    setPropertyTypeId(null);
    setGetPropertySubTypeId(null);
    event.preventDefault();
    event.persist();
    if (
      propertyTypeGroupId == event.target.dataset.propertytypegroup
    ) {
      setPropertyTypeGroupId(null);
      return;
    }
    setPropertyTypeGroupId(event.target.dataset.propertytypegroup);
  };

  const handlePropertyType = (event) => {
    setMandatoryErrorMessage(null);
    setGetPropertySubTypeId(null);
    event.preventDefault();
    event.persist();
    setGetPropertySubTypeId(null);
    if (propertyTypeId == event.target.dataset.propertytype) {
      setPropertyTypeId(null);
      return;
    }
    setPropertyTypeId(event.target.dataset.propertytype);
  };

  const handlePropertySubType = (event) => {
    setMandatoryErrorMessage(null);
    event.preventDefault();
    event.persist();
    if (
      getPropertySubTypeId == event.target.dataset.propertysubtype
    ) {
      setGetPropertySubTypeId(null);
      return;
    }
    setGetPropertySubTypeId(event.target.dataset.propertysubtype);
  };

  const handleMinChange = (event) => {
    setMinMaxError(null);
    setMin(event.target.value.trim());
  };

  const handleMaxChange = (event) => {
    setMinMaxError(null);
    setMax(event.target.value.trim());
  };

  const handleBedroomsFromChange = (event) => {
    setBedroomsFrom(event.target.value.replace(/\D/g, ''));
  };

  const handleBedroomsToChange = (event) => {
    setBedroomsTo(event.target.value.replace(/\D/g, ''));
  };

  const handlePropertyRef = (event) => {
    setMandatoryErrorMessage(null);
    if (event.target.value == '') {
      setPropertyRef(null);
      return;
    }
    setPropertyRef(event.target.value);
  };

  const handleVendorNameChange = (event) => {
    if (event.target.value == '') {
      setVendorName(null);
      return;
    }
    setVendorName(event.target.value);
  };

  const handleVendorSurnameChange = (event) => {
    if (event.target.value == '') {
      setVendorSurname(null);
      return;
    }
    setVendorSurname(event.target.value);
  };

  const handleVendorPhoneChange = (event) => {
    if (event.target.value == '') {
      setVendorPhone(null);
      return;
    }
    setVendorPhone(event.target.value);
  };

  const minFocus = () => {
    setMandatoryErrorMessage(null);
    if (min) {
      setMin(
        min
          .replace(/\.00$/, '')
          .replace(/[ ,.]/g, ' ')
          .replace(/ /g, ''),
      );
      return;
    }
    setMin('');
  };

  const maxFocus = () => {
    setMandatoryErrorMessage(null);
    if (max) {
      setMax(
        max
          .replace(/\.00$/, '')
          .replace(/[ ,.]/g, ' ')
          .replace(/ /g, ''),
      );
      return;
    }
    setMax('');
  };

  const handleMin = () => {
    let priceMoney;
    if (min) {
      priceMoney = min
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setMin(returnVal);
      return;
    }
    setMin('');
  };

  const handleMax = () => {
    let priceMoney;
    if (max) {
      priceMoney = max
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setMax(returnVal);
      return;
    }
  };

  const handleClearAll = () => {
    setPropertyRef('');
    setVendorName('');
    setVendorSurname('');
    setVendorPhone('');
    setBuyerSpecRef(null);
    setBuyerSpecName(null);
    setGetPropertyUse(null);
    setPropertyTypeGroupId(null);
    setMin('');
    setMax('');
    setBedroomsFrom('');
    setBedroomsTo('');
    setGetGeoregion(null);
    setGetZone(null);
    setGetLocalityId([]);
    setPropertyTypeId(null);
    setGetPropertySubTypeId(null);
    setRent(null);
  };

  const minmax = () => {
    if (max && min) {
      if (
        Number(min.replace(/[ ,.]/g, ' ').replace(/ /g, '')) >=
        Number(max.replace(/[ ,.]/g, ' ').replace(/ /g, ''))
      ) {
        setMinMaxError("Min can't be greater than Max");
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  useEffect(() => {
    const minMaxBoolean = () => {
      if (max && min) {
        if (
          Number(min.replace(/[ ,.]/g, ' ').replace(/ /g, '')) >=
          Number(max.replace(/[ ,.]/g, ' ').replace(/ /g, ''))
        ) {
          return false;
        }
        return true;
      } else {
        return true;
      }
    };

    setMinMaxBooleanValue(minMaxBoolean());
  }, [min, max]);

  const handleSubmit = (event) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    
    let PropertyUse =
      getPropertyUse === 'false'
        ? { residential: 'true' }
        : { commercial: 'true' };

    if (getPropertyUse === null) {
      PropertyUse = null;
    }

    let UsedFor =
      rent === 'false' ? { forsale: 'true' } : { longlet: 'true' };

    if (rent === null) {
      UsedFor = null;
    }

    let Budget =
      rent === 'false'
        ? { salePriceFrom: min, salePriceTo: max }
        : { longletPriceFrom: min, longletPriceTo: max };
    let Bedrooms = {
      BedroomsFrom:
        bedroomsFrom === '' ? null : Number(bedroomsFrom),
      BedroomsTo: bedroomsTo === '' ? null : Number(bedroomsTo),
    };

    //Pad the value with zeros if it is less than six characters long
    //This is how it works on web app
    let propertyRefWithZeros = propertyRef?.padStart(6, '0');
    
      navigate('/PropertySearchResultsLists', {
        state: {
          ...PropertyUse,
          ...UsedFor,
          ...Budget,
          ...Bedrooms,
          regionId: getgeoregion,
          zoneId: getzone,
          propertyref: propertyRefWithZeros,
          vendorName: vendorName,
          vendorSurname: vendorSurname,
          vendorPhone: vendorPhone,
          localityId: getLocalityId,
          propertyTypeGroupId: propertyTypeGroupId,
          propertyTypeId: propertyTypeId,
          propertySubtypeId: getPropertySubTypeId,
          buyerData: getBuyerData
        },
      });
      setMandatoryErrorMessage(null);

    // Used for required fields:

    // if (
    //   rent !== null &&
    //   getgeoregion !== null &&
    //   getzone !== null &&
    //   minmax()
    // ) {
    //   navigate('/PropertySearchResultsLists', {
    //     state: {
    //       ...PropertyUse,
    //       ...UsedFor,
    //       ...Budget,
    //       regionId: getgeoregion,
    //       zoneId: getzone,
    //       propertyref: propertyRef,
    //       vendorName: vendorName,
    //       vendorSurname: vendorSurname,
    //       vendorPhone: vendorPhone,
    //       localityId: getLocalityId,
    //       propertyTypeGroupId: propertyTypeGroupId,
    //       propertyTypeId: propertyTypeId,
    //       propertySubtypeId: getPropertySubTypeId,
    //     },
    //   });
    //   setMandatoryErrorMessage(null);
    // }

    // setMandatoryErrorMessage(
    //   'Please select all the required fields.',
    // );
  };

  const fetchGeoregion = () => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getgeoregiontokens',
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {});
  };

  const fetchZone = (getgeoregion) => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getzonesinregiontokens',
      params: { regionId: `${getgeoregion}` },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {});
  };

  const fetchLocality = (getzone) => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getlocalityinzonetokens',
      params: { zoneId: `${getzone}` },
      headers: {
        accept: 'application/json',
      },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {});
  };

  const fetchPropertyUse = (getPropertyUse) => {
    const options = {
      method: 'GET',
      url: `/propertytypegroup/getwithtypesbyiscommercial/${getPropertyUse}`,
      headers: {
        accept: 'application/json',
      },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {});
  };

  const fetchPropertyGroup = (propertyTypeGroupId) => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getpropertytypesingrouptokens',
      params: { groupId: `${propertyTypeGroupId}` },
      headers: {
        accept: 'application/json',
      },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {});
  };

  const fetchPropertySubType = (propertyTypeId) => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getpropertysubtypesintypetokens',
      params: { typeId: `${propertyTypeId}` },
      headers: {
        accept: 'application/json',
      },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {});
  };

  const { isLoading: isLoadingGeoregion, data: g } = useQuery(
    ['Georegion'],
    fetchGeoregion,
    {
      refetchOnWindowFocus: false,
      cacheTIme: 86400000,
    },
  );
  const { isLoading: isLoadingZone, data: gr } = useQuery(
    ['Georegion', getgeoregion],
    () => fetchZone(getgeoregion),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(getgeoregion),
      cacheTIme: 86400000,
    },
  );
  const { isLoading: isLoadingLocality, data: zl } = useQuery(
    ['getzone', getzone],
    () => fetchLocality(getzone),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(getzone),
      cacheTIme: 86400000,
    },
  );
  const { isLoading: isLoadingPropertyUse, data: puptg } = useQuery(
    ['getPropertyUse', getPropertyUse],
    () => fetchPropertyUse(getPropertyUse),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(getPropertyUse),
      cacheTIme: 86400000,
    },
  );
  const { isLoading: isLoadingPropertyGroup, data: ptgpt } = useQuery(
    ['getPropertyGroup', propertyTypeGroupId],
    () => fetchPropertyGroup(propertyTypeGroupId),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(propertyTypeGroupId),
      cacheTIme: 86400000,
    },
  );
  const { isLoading: isLoadingPropertySubType, data: ptpst } =
    useQuery(
      ['getPropertySubType', propertyTypeId],
      () => fetchPropertySubType(propertyTypeId),
      {
        refetchOnWindowFocus: false,
        enabled: Boolean(propertyTypeId),
        cacheTIme: 86400000,
      },
    );

  return (
    <div className="container pt-3 pb-4 property-form-page">
      <div className="card shadow-sm border-0 overflow-hidden property-list-card">
        <div className="property-list-hero d-flex align-items-center px-4 py-3">
          <div className="property-list-hero-icon d-flex align-items-center justify-content-center">
            <i className="fas fa-search" aria-hidden="true"></i>
          </div>
          <div className="ml-3">
            <p className="mb-1 text-uppercase text-white-50 small">
              {buyerSpecName != null ? 'Cross-Match Search' : 'Property Search'}
            </p>
            <h4 className="mb-0 text-white">Find the right property fast.</h4>
          </div>
          <button
            type="button"
            className="btn btn-light btn-sm ml-auto property-list-back"
            onClick={() => navigate('/home')}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>

        <div className="p-4">
          {(buyerSpecRef || buyerSpecName) && (
            <div className="property-form-badges">
              {buyerSpecRef && (
                <span className="property-form-badge">
                  Buyer ref: {buyerSpecRef}
                </span>
              )}
              {buyerSpecName && (
                <span className="property-form-badge">
                  Buyer spec: {buyerSpecName}
                </span>
              )}
            </div>
          )}

          <div className="property-details-card mb-3">
            <h6>Quick search</h6>
            <label className="property-details-label">Property Ref</label>
            <input
              type="text"
              className="form-control"
              value={propertyRef}
              onChange={handlePropertyRef}
              placeholder="Property Ref"
            />

            <div className="mt-3">
              <label className="property-details-label">Vendor</label>
              <div className="row">
                <div className="col-12 col-md-4 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control d-block w-100"
                    onChange={handleVendorSurnameChange}
                    placeholder="Surname"
                    value={vendorSurname}
                  />
                </div>
                <div className="col-12 col-md-4 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control d-block w-100"
                    onChange={handleVendorNameChange}
                    placeholder="First Name"
                    value={vendorName}
                  />
                </div>
                <div className="col-12 col-md-4 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control d-block w-100"
                    onChange={handleVendorPhoneChange}
                    placeholder="Phone"
                    value={vendorPhone}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="property-details-card mb-3">
            <h6>Property preferences</h6>
            <div className="mb-3">
              <label className="property-details-label">Property Use</label>
              <div className="property-pill-grid">
                <button
                  type="button"
                  className={`property-pill ${
                    getPropertyUse === 'false'
                      ? 'property-pill--active'
                      : ''
                  }`}
                  onClick={handlePropertyUse}
                  data-user="false"
                >
                  Residential
                </button>
                <button
                  type="button"
                  className={`property-pill ${
                    getPropertyUse === 'true'
                      ? 'property-pill--active'
                      : ''
                  }`}
                  onClick={handlePropertyUse}
                  data-user="true"
                >
                  Commercial
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="property-details-label">Used for</label>
              <div className="property-pill-grid">
                <button
                  type="button"
                  className={`property-pill ${
                    rent === 'false' || forSale === 'true'
                      ? 'property-pill--active'
                      : ''
                  }`}
                  onClick={handleRentChange}
                  data-rent="false"
                >
                  For Sale
                </button>
                <button
                  type="button"
                  className={`property-pill ${
                    rent === 'true' || longlet === 'true'
                      ? 'property-pill--active'
                      : ''
                  }`}
                  onClick={handleRentChange}
                  data-rent="true"
                >
                  To Let
                </button>
              </div>
            </div>

            <div>
              <label className="property-details-label">Budget</label>
              <div className="row">
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className={`form-control ${
                      minMaxError && 'border-danger'
                    } d-block w-100`}
                    value={min}
                    onChange={handleMinChange}
                    onBlur={handleMin}
                    onFocus={minFocus}
                    placeholder="Min"
                  />
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className={`form-control ${
                      minMaxError && 'border-danger'
                    } d-block w-100`}
                    value={max}
                    onChange={handleMaxChange}
                    onBlur={handleMax}
                    onFocus={maxFocus}
                    placeholder="Max"
                  />
                </div>
              </div>
              {minMaxError && (
                <small className="form-text text-danger d-block mb-2">
                  {minMaxError}
                </small>
              )}
            </div>

            <div className="mt-2">
              <label className="property-details-label">
                No of Bedrooms
              </label>
              <div className="row">
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="number"
                    min="0"
                    step="1"
                    autoComplete="off"
                    className="form-control d-block w-100"
                    value={bedroomsFrom}
                    onChange={handleBedroomsFromChange}
                    placeholder="From"
                  />
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="number"
                    min="0"
                    step="1"
                    autoComplete="off"
                    className="form-control d-block w-100"
                    value={bedroomsTo}
                    onChange={handleBedroomsToChange}
                    placeholder="To"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="property-details-card mb-3">
            <h6>Location</h6>
            {isLoadingGeoregion && <CenteredSpinner />}
            <Georegion
              georegion={g}
              handleGeoRegion={handleGeoRegion}
              isLoadingGeoregion={isLoadingGeoregion}
              getgeoregion={getgeoregion}
            />
            {getgeoregion && isLoadingZone && <CenteredSpinner />}
            <GeoZone
              geoRegionInZone={gr}
              handleZone={handleZone}
              isLoadingZone={isLoadingZone}
              getZone={getzone}
            />
            {getzone && isLoadingLocality && <CenteredSpinner />}
            <ZoneLocality
              zoneInLocality={zl}
              handleLocality={handleLocality}
              isLoadingLocality={isLoadingLocality}
              selectedLocalityIds={getLocalityId}
            />
          </div>

          <div className="property-details-card mb-3">
            <h6>Property type</h6>
            {getPropertyUse && isLoadingPropertyUse && <CenteredSpinner />}
            <PropertyUsePropertyTypeGroup
              propertyUseInPropertyTypeGroup={puptg}
              handlePropertyTypeGroup={handlePropertyTypeGroup}
              isLoadingPropertyUse={isLoadingPropertyUse}
              propertyTypeGroupId={propertyTypeGroupId}
            />
            {propertyTypeGroupId && isLoadingPropertyGroup && <CenteredSpinner />}
            <PropertyTypeGroupPropertyType
              propertyTypeGroupInPropertyType={ptgpt}
              handlePropertyType={handlePropertyType}
              isLoadingPropertySubType={isLoadingPropertySubType}
              propertyTypeId={propertyTypeId}
            />
            {propertyTypeId && isLoadingPropertySubType && <CenteredSpinner />}
            <PropertyTypePropertySubType
              PropertyTypeInPropertySubType={ptpst}
              handlePropertySubType={handlePropertySubType}
              isLoadingPropertyGroup={isLoadingPropertyGroup}
              getPropertySubTypeId={getPropertySubTypeId}
            />
          </div>

          {mandatoryErrorMessage && (
            <small className="form-text text-danger d-block mb-3">
              {mandatoryErrorMessage}
            </small>
          )}

          <div className="property-form-actions d-flex flex-column flex-sm-row align-items-stretch justify-content-between">
            <button
              type="button"
              className="btn btn-light property-secondary-btn mb-2 mb-sm-0"
              onClick={handleClearAll}
            >
              Clear
            </button>
            <button
              type="button"
              className="btn property-primary-btn"
              onClick={handleSubmit}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
